var map = {
	"./after_1.jpg": 8528,
	"./after_2.PNG": 8156,
	"./after_3.jpg": 8818,
	"./after_4.PNG": 6490,
	"./before_1.jpg": 1949,
	"./before_2.jpg": 2690,
	"./before_3.jpg": 5359,
	"./before_4.jpg": 4548,
	"./before_5.jpg": 1921,
	"./before_6.PNG": 2371
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3624;